import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "telFormat",
  standalone: true,
})
export class TelFormatPipe implements PipeTransform {
  transform(tel: string): string {
    if (!tel || !/^\d{9,12}$/.test(tel)) {
      return tel;
    }

    if (tel.length === 9) {
      return tel.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
    } else if (tel.length === 10) {
      return tel.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    } else if (tel.length === 11) {
      return tel.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    } else if (tel.length === 12) {
      return tel.replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
    }

    return tel;
  }
}
